import axios from "./httpClient";

export function getApiLogs(params = {}) {
  return axios.get("/api-logs", { params }).then((response) => {
    // Transform the response to match the format expected by usePagination
    return {
      data: {
        items: response.data.data,
        totalItems: response.data.pagination.total,
        totalPages: Math.ceil(
          response.data.pagination.total / response.data.pagination.limit,
        ),
        currentPage:
          Math.floor(
            response.data.pagination.skip / response.data.pagination.limit,
          ) + 1,
      },
    };
  });
}
